import React from "react"
import Icon from '@ant-design/icons';

function IconSvg()
{
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ stroke: "currentcolor" }} xmlns="http://www.w3.org/2000/svg">
      <g id="user">
        <path id="Vector" d="M16.3333 18V16.3333C16.3333 15.4493 15.9821 14.6014 15.357 13.9763C14.7319 13.3512 13.8841 13 13 13H6.33333C5.44928 13 4.60143 13.3512 3.97631 13.9763C3.35119 14.6014 3 15.4493 3 16.3333V18" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Vector_2" d="M9.66634 9.66667C11.5073 9.66667 12.9997 8.17428 12.9997 6.33333C12.9997 4.49238 11.5073 3 9.66634 3C7.82539 3 6.33301 4.49238 6.33301 6.33333C6.33301 8.17428 7.82539 9.66667 9.66634 9.66667Z" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export function IconUser(props)
{
  return <Icon component={IconSvg} {...props} />
}

